<form [formGroup]="othersForm">
    <div class="edit-container-params" *ngIf="editable">

        <h4>{{'BLUETOOTH_NAME'|translate}}</h4>
        <mat-form-field>
            <mat-label>{{'BLUETOOTH_NAME'|translate}} :</mat-label>
            <input matInput placeholder="''NAME' | translate" formControlName="bluetoothName" type="text"
                   (keyup)="setDeviceWithForm()" [readonly]="!unblockBluetoothName">
        </mat-form-field>
    </div>
    <br clear="left"/>
    <div class="edit-container-params" *ngIf="editable">

        <h4>{{'PARAMETERS'|translate}}</h4>


        <mat-form-field>
            <mat-label>{{'PERIOD_ACQ'|translate}} : period (ms)</mat-label>
            <input matInput placeholder="Period (ms) " formControlName="periodAcq" type="number"
                   (keyup)="setDeviceWithForm()">
        </mat-form-field>

        <mat-form-field>
            <mat-label> {{'STATIC_RECORD'|translate}} : period (min)</mat-label>
            <input matInput placeholder="Period (min)" formControlName="staticRecordPeriod" type="number"
                   (keyup)="setDeviceWithForm()">
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{'EXTENSION_BOARD_TYPE'|translate}}</mat-label>
            <mat-select placeholder="Extension" formControlName="boardType_extension"
                        (selectionChange)="setDeviceWithForm()">
                <mat-option value="no-extension">no-extension</mat-option>
                <mat-option value="4-20ma">4-20ma</mat-option>
                <mat-option value="debug-uart">debug-uart</mat-option>
                <mat-option value="sms-module">sms-module</mat-option>
            </mat-select>
        </mat-form-field>

      <mat-form-field *ngIf="sensorType===18">
        <mat-label>{{'MEASUREMENT_MODE'|translate}}</mat-label>
        <mat-select placeholder="Measurement Mode" formControlName="MeasurementMode"
                    (selectionChange)="setDeviceWithForm()">
          <mat-option value="Static">Static</mat-option>
          <mat-option value="Dynamic">Dynamic</mat-option>
        </mat-select>
      </mat-form-field>

    </div>
</form>

<div class="edit-container-params" *ngIf="!editable">

    <h4>{{'BLUETOOTH_NAME'|translate}}</h4>
    <mat-form-field>
        <mat-label>{{'BLUETOOTH_NAME'|translate}} :</mat-label>
        <input matInput placeholder="''NAME' | translate" [value]="deviceParamLirisV3.bluetoothName" [readonly]="true">
    </mat-form-field>
</div>
<br clear="left"/>


<div *ngIf="!editable" class="read-container-params">
    <h4>{{'PARAMETERS'|translate}}</h4>
    <mat-form-field>
        <mat-label>{{'PERIOD_ACQ'|translate}} : period (ms)</mat-label>
        <input matInput placeholder="Period (ms) " [value]="deviceParamLirisV3.periodAcq" [readonly]="true">
    </mat-form-field>
    <mat-form-field>
        <mat-label> {{'STATIC_RECORD'|translate}} : period (min)</mat-label>
        <input matInput placeholder="Period (min)" [value]="deviceParamLirisV3.staticRecordPeriod" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
        <mat-label>{{'EXTENSION_BOARD_TYPE'|translate}}</mat-label>
        <mat-select placeholder="Extension" [value]="deviceParamLirisV3.boardType.extension" [disabled]="true">
            <mat-option value="no-extension">no-extension</mat-option>
            <mat-option value="4-20ma">4-20ma</mat-option>
            <mat-option value="debug-uart">debug-uart</mat-option>
            <mat-option value="sms-module">sms-module</mat-option>
        </mat-select>
    </mat-form-field>
  <mat-form-field *ngIf="sensorType===18">
    <mat-label>{{'MEASUREMENT_MODE'|translate}}</mat-label>
    <mat-select placeholder="Measurement Mode" [value]="deviceParamLirisV3.MeasurementMode === 0 ? 'Dynamic' : 'Static'" [disabled]="true">
      <mat-option value="Static">Static</mat-option>
      <mat-option value="Dynamic">Dynamic</mat-option>
    </mat-select>
  </mat-form-field>

</div>
